import styled from 'styled-components';

export const FlagWrapper = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  border-radius: 2px;
  overflow: hidden;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;
